import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, updateInternalConfig, readAllTenant, exportSelectAllQueues, exportSelectAllTrunks, getContextsByTenant, getContextsFilteredByTenant, getInternalConfigById, getIntegrationsByAccountcode } from '../../../services';
import { scopeByTenant } from '../../../services/tenantScope';
import AudioSelectorUploads from '../Audio/AudioSelectorUploads';
import TimeConditionManager from '../shared/TimeConditionManager';
import MohConfiguration from '../shared/MohConfiguration';

import Loading from '../../../components/Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './InternalCallsForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faSave, faArrowLeft, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { isDestinationContext } from '../../../services/destinationContexts';

function InternalCallsEdit() {
  const getItensStateGlobal = useContext(PbxContext);
  const { itemsSelectedToEdit, toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({
    tenant: '',
    mask: '',
    destination_main: '',
    destination_type_main: 'endpoint',
    trunk_name_main: '',
    is_dynamic: false,
    description: '',
    recording_enabled: false,
    recording_format: 'wav',
    moh_enabled: false,
    moh_class: '',
    audio_enabled_main: false,
    audio_file_main: '',
    audio_type_main: '',
    audio_accountcode_main: '',
    audio_method_main: 'playback',
    overflows: [
      {
        timeout: '',
        destination_overflow: '',
        destination_type: 'endpoint',
        trunk_name: '',
        audio_enabled: false,
        audio_file: '',
        audio_type: '',
        audio_accountcode: '',
        audio_method: 'playback'
      }
    ],
    gotoiftime_rules: [],
    gotoiftime_enabled: false
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tenants, setTenants] = useState([]);
  const [contextsFiltered, setContextsFiltered] = useState([]);

  const processMask = (mask) => {
    if (!mask) return mask;
    
    const cleanMask = mask.startsWith('_') ? mask.substring(1) : mask;
    
    const hasUppercaseWildcards = /[NXZ]/.test(cleanMask);
    
    if (hasUppercaseWildcards && !mask.startsWith('_')) {
      return `_${cleanMask}`;
    }
    
    return cleanMask;
  };
  const [queues, setQueues] = useState([]);
  const [trunks, setTrunks] = useState([]);
  const [contexts, setContexts] = useState([]);
  const [hasWhatsAppIntegration, setHasWhatsAppIntegration] = useState(false);
  const [showOverflowDeleteConfirm, setShowOverflowDeleteConfirm] = useState(false);
  const [pendingIsDynamicChange, setPendingIsDynamicChange] = useState(null);

  const [alert, setAlert] = useState({
    show: false,
    type: '',
    message: ''
  });

  const changeVisibilityMessage = (show, elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      if (show) {
        element.classList.remove('is-hidden');
      } else {
        element.classList.add('is-hidden');
      }
    }
  };

  const changeBorderToRedOrNormal = (isValid, fieldName) => {
    const element = document.querySelector(`[name="${fieldName}"]`);
    if (element) {
      if (isValid) {
        element.classList.remove('is-danger');
      } else {
        element.classList.add('is-danger');
      }
    }
  };

  const fetchQueues = async (idtenant) => {
    try {
      let queuesList = await exportSelectAllQueues();
      if (queuesList === undefined) return setLoading(true);   
      
      queuesList = scopeByTenant(queuesList, (queue) => queue.accountcodequeue, idtenant);
      
      queuesList = queuesList ? queuesList.map((s) => ({
        name: s.namequeue,
        description: s.descqueue || 'Sem descrição'
      })) : [];
      
      setQueues(queuesList);
      return true;
    } catch (error) {
      console.error('Erro ao buscar filas:', error);
      setQueues([]);
      return false;
    }
  };

  const fetchTrunks = async (idtenant) => {
    try {
      let trunksList = await exportSelectAllTrunks();
      if (trunksList === undefined) return setLoading(true);
      
      trunksList = scopeByTenant(trunksList, (trunk) => trunk.tenant, idtenant);
      
      setTrunks(trunksList);
      return true;
    } catch (error) {
      console.error('Erro ao buscar troncos:', error);
      setTrunks([]);
      return false;
    }
  };

  const fetchContexts = useCallback(async (tenant) => {
    try {
      const response = await getContextsByTenant(tenant);
      
      if (response.success) {
        setContexts(response.data);
      } else {
        console.error('Erro ao buscar contextos:', response.error);
        setContexts([]);
      }
    } catch (error) {
      console.error('Erro ao buscar contextos:', error);
      setContexts([]);
    }
  }, []);

  const checkWhatsAppIntegration = useCallback(async (tenant) => {
    try {
      const response = await getIntegrationsByAccountcode(tenant);
      
      if (response && response.success && response.data && response.data.length > 0) {
        setHasWhatsAppIntegration(true);
      } else {
        setHasWhatsAppIntegration(false);
      }
    } catch (error) {
      console.error('Erro ao buscar integrações:', error);
      setHasWhatsAppIntegration(false);
    }
  }, []);

  const fetchContextsFiltered = useCallback(async (tenant) => {
    try {
      const response = await getContextsFilteredByTenant(tenant);
      if (response && response.success && response.data) {
        setContextsFiltered(response.data);
      } else {
        setContextsFiltered([]);
      }
    } catch (error) {
      console.error('Erro ao buscar contextos filtrados:', error);
      setContextsFiltered([]);
    }
  }, []);

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    
    if (!itemsSelectedToEdit || !itemsSelectedToEdit.id) {
      return history.push('/config/chamadas/internas');
    }

    let fullConfigData;
    try {
      const response = await getInternalConfigById(itemsSelectedToEdit.id);
      if (response && response.success && response.data) {
        fullConfigData = response.data;
      } else {
        console.error('Erro ao buscar dados completos da configuração:', response);
        fullConfigData = itemsSelectedToEdit;
      }
    } catch (error) {
      console.error('Erro ao buscar dados completos:', error);
      fullConfigData = itemsSelectedToEdit;
    }

    try {
      let fetchTenants = await readAllTenant();
      if (fetchTenants) {
        const { user: { idtenant } } = dataUser;
        fetchTenants = scopeByTenant(fetchTenants, (tenant) => tenant.short_name, idtenant);
        setTenants(fetchTenants);
      }
    } catch (error) {
      console.error('Erro ao buscar tenants:', error);
      setTenants([]);
    }

    const { user: { idtenant } } = dataUser;
    await fetchQueues(idtenant);
    await fetchTrunks(idtenant);
    await fetchContexts(fullConfigData.tenant || idtenant);
    await fetchContextsFiltered(fullConfigData.tenant || idtenant);
    await checkWhatsAppIntegration(fullConfigData.tenant || idtenant);

    let destinationMain = fullConfigData.destination_main || '';
    let trunkNameMain = '';
    
    if (fullConfigData.destination_type_main === 'external' && destinationMain.includes('@')) {
      const parts = destinationMain.split('@');
      destinationMain = parts[0];
      trunkNameMain = parts[1] || '';
    }

    const processedOverflows = fullConfigData.overflows && fullConfigData.overflows.length > 0 
      ? fullConfigData.overflows.map(overflow => {
          if (overflow.destination_type === 'external' && overflow.destination_overflow && overflow.destination_overflow.includes('@')) {
            const parts = overflow.destination_overflow.split('@');
            return {
              ...overflow,
              destination_overflow: parts[0],
              trunk_name: parts[1] || ''
            };
          }
          return { ...overflow, trunk_name: overflow.trunk_name || '' };
        })
      : [];

    setValues({
      tenant: fullConfigData.tenant || '',
      mask: fullConfigData.mask || '',
      destination_main: destinationMain,
      destination_type_main: fullConfigData.destination_type_main || 'endpoint',
      trunk_name_main: trunkNameMain,
      is_dynamic: fullConfigData.is_dynamic === true || fullConfigData.is_dynamic === 't' || fullConfigData.is_dynamic === 'true',
      description: fullConfigData.description || '',
      recording_enabled: fullConfigData.recording_enabled === true || fullConfigData.recording_enabled === 't' || fullConfigData.recording_enabled === 'true',
      recording_format: fullConfigData.recording_format || 'wav',
      moh_enabled: fullConfigData.moh_enabled === true || fullConfigData.moh_enabled === 't' || fullConfigData.moh_enabled === 'true',
      moh_class: fullConfigData.moh_class || '',
      audio_enabled_main: fullConfigData.audio_enabled === true || fullConfigData.audio_enabled === 't' || fullConfigData.audio_enabled === 'true',
      audio_file_main: fullConfigData.audio_file || '',
      audio_type_main: fullConfigData.audio_type || '',
      audio_accountcode_main: fullConfigData.audio_accountcode || '',
      audio_method_main: fullConfigData.audio_method || 'playback',
      overflows: processedOverflows,
      gotoiftime_rules: fullConfigData.gotoiftime_rules || [],
      gotoiftime_enabled: fullConfigData.gotoiftime_rules && fullConfigData.gotoiftime_rules.length > 0
    });

    setLoading(false);
  }, [history, itemsSelectedToEdit]);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  useEffect(() => {
    if (values.tenant && values.tenant.trim() !== '') {
      fetchContexts(values.tenant);
      fetchContextsFiltered(values.tenant);
      checkWhatsAppIntegration(values.tenant);
    } else {
      setContexts([]);
      setContextsFiltered([]);
      setHasWhatsAppIntegration(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.tenant]);

  useEffect(() => {
    const requiredFields = values.destination_type_main === 'whatsapp' 
      ? ['tenant', 'mask', 'destination_type_main']
      : ['tenant', 'mask', 'destination_main', 'destination_type_main'];
    
    const allFieldsFilled = requiredFields.every(field => 
      values[field] && values[field].toString().trim() !== ''
    );
    
    const overflowsValid = (() => {
      if (values.is_dynamic) {
        const hasValidOverflow = values.overflows.some(overflow => {
          if (overflow.destination_type === 'whatsapp') {
            return overflow.timeout !== '' &&
              !isNaN(parseInt(overflow.timeout)) &&
              parseInt(overflow.timeout) >= 1 && 
              parseInt(overflow.timeout) <= 300;
          }
          return overflow.destination_overflow && 
            overflow.destination_overflow.trim() !== '' &&
            overflow.timeout !== '' &&
            !isNaN(parseInt(overflow.timeout)) &&
            parseInt(overflow.timeout) >= 1 && 
            parseInt(overflow.timeout) <= 300;
        });
        return hasValidOverflow;
      } else {
        return values.overflows.every(overflow => {
          if (overflow.destination_type === 'whatsapp') {
            if (overflow.timeout !== '') {
              const timeoutNum = parseInt(overflow.timeout);
              return !isNaN(timeoutNum) && timeoutNum >= 1 && timeoutNum <= 300;
            }
            return true;
          }
          if (overflow.destination_overflow && overflow.destination_overflow.trim() !== '') {
            const timeoutNum = parseInt(overflow.timeout);
            return !isNaN(timeoutNum) && timeoutNum >= 1 && timeoutNum <= 300;
          }
          return true;
        });
      }
    })();
    
    const allFieldsValid = requiredFields.every(field => {
      if (validate[field]) {
        return validate[field].isValid;
      }
      if (values[field] && values[field].toString().trim() !== '') {
        const fieldValidation = validateField(field, values[field]);
        return fieldValidation.isValid;
      }
      return false;
    });

    let descriptionValid = true;
    if (values.description && values.description.trim() !== '') {
      const descriptionValidation = validate.description || validateField('description', values.description);
      descriptionValid = descriptionValidation.isValid;
    }

    setDisable(!(allFieldsFilled && allFieldsValid && descriptionValid && overflowsValid));
  }, [values, validate]);

  useEffect(() => {
    setDisable(false);
  }, [values.recording_enabled, values.recording_format, values.is_dynamic, values.gotoiftime_rules]);

  const changeScreen = (check, name) => {
    changeBorderToRedOrNormal(check, name);
    changeVisibilityMessage(!check, `${name}-invalid-data`);
  };

  const validateField = (name, value) => {
    let isValid = true;
    let errorMessage = '';

    switch (name) {
      case 'tenant':
        isValid = value && value.trim().length >= 1;
        errorMessage = 'Selecione um cliente/tenant';
        break;
      case 'mask':
        isValid = value && value.trim().length >= 1 && value.trim().length <= 50;
        errorMessage = 'Máscara deve ter entre 1 e 50 caracteres';
        break;
      case 'destination_main':
        isValid = value && value.trim().length >= 1 && value.trim().length <= 100;
        errorMessage = 'Destino principal deve ter entre 1 e 100 caracteres';
        break;
      case 'destination_type_main':
        isValid = value && ['endpoint', 'queue', 'external', 'disa', 'whatsapp'].includes(value);
        errorMessage = 'Tipo de destino deve ser endpoint, queue, external, disa ou whatsapp';
        break;
      case 'description':
        if (value.trim().length === 0) {
          isValid = true;
        } else if (value.length > 500) {
          isValid = false;
          errorMessage = 'Descrição deve ter no máximo 500 caracteres';
        } else {
          isValid = true;
        }
        break;
      default:
        break;
    }

    changeScreen(isValid, name);
    return { isValid, errorMessage };
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    
    if (name === 'is_dynamic' && type === 'checkbox') {
      if (!checked && values.is_dynamic && values.overflows && values.overflows.some(overflow => 
        overflow.destination_overflow && overflow.destination_overflow.trim() !== ''
      )) {
        setPendingIsDynamicChange(checked);
        setShowOverflowDeleteConfirm(true);
        return;
      }
    }

    let newValues = { ...values, [name]: type === 'checkbox' ? checked : value };

    if (name === 'destination_type_main') {
      newValues = {
        ...newValues,
        destination_main: value === 'whatsapp' ? 'whatsapp' : '',
        trunk_name_main: ''
      };
    }
    
    setValues(newValues);

    if (name !== 'description' || (name === 'description' && value.trim() !== '')) {
      const validation = validateField(name, type === 'checkbox' ? checked : value);
      setValidate({
        ...validate,
        [name]: validation
      });
    }
  };

  const confirmOverflowDeletion = () => {
    setValues({
      ...values,
      is_dynamic: pendingIsDynamicChange,
      overflows: []
    });
    setShowOverflowDeleteConfirm(false);
    setPendingIsDynamicChange(null);
  };

  const cancelOverflowDeletion = () => {
    setShowOverflowDeleteConfirm(false);
    setPendingIsDynamicChange(null);
  };

  const addOverflow = () => {
    setValues({
      ...values,
      is_dynamic: true,
      overflows: [
        ...values.overflows,
        {
          timeout: '',
          destination_overflow: '',
          destination_type: 'endpoint',
          trunk_name: '',
          audio_enabled: false,
          audio_file: '',
          audio_type: '',
          audio_accountcode: '',
          audio_method: 'playback'
        }
      ]
    });
  };

  const removeOverflow = (index) => {
    const newOverflows = values.overflows.filter((_, i) => i !== index);
    
    const updatedValues = {
      ...values,
      overflows: newOverflows
    };
    
    if (newOverflows.length === 0) {
      updatedValues.is_dynamic = false;
    }
    
    setValues(updatedValues);
  };

  const updateOverflow = (index, field, value) => {
    const newOverflows = [...values.overflows];
    
    if (field === 'timeout' && value === '') {
      newOverflows[index] = {
        ...newOverflows[index],
        [field]: ''
      };
    } else if (field === 'timeout') {
      newOverflows[index] = {
        ...newOverflows[index],
        [field]: parseInt(value) || ''
      };
    } else if (field === 'destination_type' && value === 'cycle') {
      newOverflows[index] = {
        ...newOverflows[index],
        [field]: value,
        destination_overflow: 'CYCLE_RESTART',
        trunk_name: ''
      };
    } else if (field === 'destination_type' && value === 'external') {
      newOverflows[index] = {
        ...newOverflows[index],
        [field]: value,
        destination_overflow: newOverflows[index].destination_overflow === 'CYCLE_RESTART' ? '' : newOverflows[index].destination_overflow,
        trunk_name: newOverflows[index].trunk_name || ''
      };
    } else if (field === 'destination_type' && value === 'whatsapp') {
      newOverflows[index] = {
        ...newOverflows[index],
        [field]: value,
        destination_overflow: 'whatsapp',
        trunk_name: ''
      };
    } else if (field === 'destination_type' && value !== 'cycle' && value !== 'external' && value !== 'whatsapp') {
      newOverflows[index] = {
        ...newOverflows[index],
        [field]: value,
        destination_overflow: newOverflows[index].destination_overflow === 'CYCLE_RESTART' ? '' : newOverflows[index].destination_overflow,
        trunk_name: ''
      };
    } else {
      newOverflows[index] = {
        ...newOverflows[index],
        [field]: value
      };
    }
    
    setValues({
      ...values,
      overflows: newOverflows
    });
  };

  const addGotoIfTimeRule = () => {
    setValues({
      ...values,
      gotoiftime_rules: [
        ...values.gotoiftime_rules,
        {
          time_range: '*',
          days_of_week: '*',
          days_of_month: '*',
          months: '*',
          destination: '',
          destination_type: 'context',
          context_name: '',
          extension_name: '',
          priority: 1,
          description: ''
        }
      ]
    });
  };

  const removeGotoIfTimeRule = (index) => {
    const newRules = values.gotoiftime_rules.filter((_, i) => i !== index);
    setValues({
      ...values,
      gotoiftime_rules: newRules
    });
  };

  const updateGotoIfTimeRule = (index, field, value) => {
    const newRules = [...values.gotoiftime_rules];
    newRules[index] = {
      ...newRules[index],
      [field]: value
    };
    
    setValues({
      ...values,
      gotoiftime_rules: newRules
    });
  };

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      setAlert({ show: false, type: '', message: '' });
    }, 5000);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (disable || saving) return;

    setSaving(true);

    try {
      const validOverflows = values.overflows
        .filter(overflow => 
          overflow.destination_overflow && overflow.destination_overflow.trim() !== ''
        )
        .map(overflow => {
          if (overflow.destination_type === 'external' && overflow.trunk_name) {
            return {
              ...overflow,
              destination_overflow: `${overflow.destination_overflow}@${overflow.trunk_name}`
            };
          }
          return overflow;
        });

      let destinationMain = values.destination_main;
      
      if (values.destination_type_main === 'external' && values.trunk_name_main) {
        destinationMain = `${values.destination_main}@${values.trunk_name_main}`;
      }

      const filledGotoIfTimeRules = values.gotoiftime_rules.filter(rule => {
        const hasDestination = (rule.context_name && rule.context_name.trim() !== '') || 
                               (rule.destination && rule.destination.trim() !== '');
        const hasTimeRange = rule.time_range && rule.time_range.trim() !== '';
        return hasDestination && hasTimeRange;
      }).map(rule => ({
        ...rule,
        destination: `${rule.context_name},${rule.extension_name},${rule.priority || 1}`
      }));

      const processedMask = processMask(values.mask);

      const dataToUpdate = {
        tenant: values.tenant,
        mask: processedMask,
        destination_main: destinationMain,
        destination_type_main: values.destination_type_main,
        is_dynamic: values.is_dynamic,
        description: values.description || '',
        recording_enabled: values.recording_enabled || false,
        recording_format: values.recording_format || 'wav',
        moh_enabled: values.moh_enabled || false,
        moh_class: values.moh_class || null,
        audio_enabled: values.audio_enabled_main || false,
        audio_file: values.audio_file_main || '',
        audio_type: values.audio_type_main || '',
        audio_accountcode: values.audio_accountcode_main || values.tenant,
        overflows: validOverflows,
        gotoiftime_rules: filledGotoIfTimeRules
      };

      const response = await updateInternalConfig(itemsSelectedToEdit.id, dataToUpdate);

      console.log('Resposta do backend:', response);

      if (response && response.success) {
        showAlert('success', 'Configuração atualizada com sucesso!');
        setTimeout(() => {
          toggleIsHidden();
          toggleIsChangeFormElements();
          history.push('/config/chamadas/internas');
        }, 2000);
      } else {
        console.error('Erro ao atualizar configuração:', response);
        let errorMessage = 'Erro ao atualizar configuração. Verifique os dados e tente novamente.';
        
        if (response && response.error) {
          errorMessage = response.error;
        }
        
        showAlert('danger', errorMessage);
      }
    } catch (error) {
      console.error('Erro ao atualizar configuração:', error);
      showAlert('danger', 'Erro ao atualizar configuração. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <div className="internal-calls-form-container">
        <div className="internal-calls-form-header">
          <div className="internal-calls-form-title-wrapper">
            <svg className="internal-calls-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            <div>
              <h1 className="internal-calls-form-title">Editar Configuração</h1>
              <p className="internal-calls-form-subtitle">Modificar chamada interna</p>
            </div>
          </div>
          <Link to="/config/chamadas/internas" className="btn-back">
            <FontAwesomeIcon icon={faArrowLeft} />
            Voltar
          </Link>
        </div>

        {alert.show && (
          <div className="alerts-section">
            <div className={`alert-message alert-${alert.type}`}>
              <div className="alert-header">
                <span>{alert.type === 'success' ? 'Sucesso' : alert.type === 'danger' ? 'Erro' : 'Aviso'}</span>
                <button className="alert-close" onClick={() => setAlert({ ...alert, show: false })}>×</button>
              </div>
              <div className="alert-body">
                <div style={{ whiteSpace: 'pre-line' }}>{alert.message}</div>
              </div>
            </div>
          </div>
        )}

              <form onSubmit={handleSubmit}>
                <div className="columns">
                  <div className="column is-6">
                    <div className="field">
                      <label className="label">Cliente/Tenant *</label>
                      <div className="control">
                        <div className="select is-fullwidth">
                          <select
                            name="tenant"
                            value={values.tenant}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Selecione um cliente</option>
                            {tenants.map((tenant) => (
                              <option key={tenant.short_name} value={tenant.short_name}>
                                {tenant.name} ({tenant.short_name})
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <p 
                        className="help is-danger is-hidden" 
                        id="tenant-invalid-data"
                      >
                        {validate.tenant?.errorMessage}
                      </p>
                      <p className="help">
                        Selecione o cliente/tenant para esta configuração
                      </p>
                    </div>
                  </div>

                  <div className="column is-6">
                    <div className="field">
                      <label className="label">Máscara *</label>
                      <div className="control">
                        <input
                          className="input"
                          type="text"
                          name="mask"
                          value={values.mask}
                          onChange={handleInputChange}
                          placeholder="Ex: 2002, 204X, 20XX"
                          maxLength="50"
                          required
                        />
                      </div>
                      <p 
                        className="help is-danger is-hidden" 
                        id="mask-invalid-data"
                      >
                        {validate.mask?.errorMessage}
                      </p>
                      <p className="help">
                        Máscara do dialplan. Use N (2-9), X (0-9), Z (1-9) para padrões. 
                        Underscore (_) será adicionado automaticamente quando necessário.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="columns">
                  <div className="column is-6">
                    <div className="field">
                      <label className="label">Tipo de Destino Principal *</label>
                      <div className="control">
                        <div className="select is-fullwidth">
                        <select
                          name="destination_type_main"
                          value={values.destination_type_main}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="endpoint">Endpoint (Ramal)</option>
                          <option value="queue">Queue (Fila)</option>
                          <option value="external">Externo</option>
                          <option value="disa">DISA (Goto)</option>
                          <option value="whatsapp" disabled={!hasWhatsAppIntegration}>
                            WhatsApp {!hasWhatsAppIntegration && '(Requer integração cadastrada)'}
                          </option>
                        </select>
                        </div>
                      </div>
                      <p 
                        className="help is-danger is-hidden" 
                        id="destination_type_main-invalid-data"
                      >
                        {validate.destination_type_main?.errorMessage}
                      </p>
                      <p className="help">
                        Tipo do destino principal.
                      </p>
                    </div>
                  </div>

                  <div className="column is-6">
                    <div className="field">
                      <label className="label">Destino Principal {values.destination_type_main !== 'whatsapp' && '*'}</label>
                      <div className="control">
                        {values.destination_type_main === 'whatsapp' ? (
                          <input
                            className="input"
                            type="text"
                            name="destination_main"
                            value="WhatsApp (gerenciado automaticamente pelo AGI)"
                            disabled
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                          />
                        ) : values.destination_type_main === 'queue' ? (
                          <div className="select is-fullwidth">
                            <select
                              name="destination_main"
                              value={values.destination_main}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Selecione uma fila</option>
                              {queues.map((queue, index) => (
                                <option key={index} value={queue.name}>
                                  {queue.name} ({queue.description})
                                </option>
                              ))}
                            </select>
                          </div>
                        ) : values.destination_type_main === 'disa' ? (
                          <div className="select is-fullwidth">
                            <select
                              name="destination_main"
                              value={values.destination_main}
                              onChange={handleInputChange}
                              required
                            >
                              <option value="">Selecione um contexto DISA</option>
                              {contexts.filter(context => {
                                const contextName = (context.name || '').toLowerCase();
                                return isDestinationContext(contextName);
                              }).map((context, index) => (
                                <option key={index} value={context.name}>
                                  {context.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        ) : (
                          <input
                            className="input"
                            type="text"
                            name="destination_main"
                            value={values.destination_main}
                            onChange={handleInputChange}
                            placeholder={
                              values.destination_type_main === 'endpoint' 
                                ? "Ex: 2002, 2001" 
                                : "Ex: 2002, 2001, ura-clienteteste-clq,menu,1"
                            }
                            maxLength="100"
                            required
                          />
                        )}
                      </div>
                      <p 
                        className="help is-danger is-hidden" 
                        id="destination_main-invalid-data"
                      >
                        {validate.destination_main?.errorMessage}
                      </p>
                      <p className="help">
                        {values.destination_type_main === 'whatsapp'
                          ? '🟢 A chamada será encaminhada para o WhatsApp automaticamente via AGI. A integração configurada será utilizada para envio.'
                          : values.destination_type_main === 'queue' 
                          ? 'Selecione a fila de destino das chamadas'
                          : values.destination_type_main === 'endpoint'
                          ? 'Número do ramal de destino (ex: 2002, 2001)'
                          : values.destination_type_main === 'disa'
                          ? 'Selecione o contexto DISA/URA para encaminhar a chamada'
                          : 'Destino principal para onde a chamada será direcionada'
                        }
                      </p>
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label className="label">Descrição (Opcional)</label>
                  <div className="control">
                    <textarea
                      className="textarea"
                      name="description"
                      value={values.description}
                      onChange={handleInputChange}
                      placeholder="Descrição adicional sobre esta configuração (máximo 500 caracteres)"
                      rows="3"
                      maxLength="500"
                    />
                  </div>
                  <p 
                    className="help is-danger is-hidden" 
                    id="description-invalid-data"
                  >
                    {validate.description?.errorMessage}
                  </p>
                  <p className="help">
                    Descrição opcional para identificar a configuração ({values.description.length}/500 caracteres)
                  </p>
                </div>

                <div className="columns">
                  <div className="column is-6">
                    <div className="field">
                      <div className="control">
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="is_dynamic"
                            checked={values.is_dynamic}
                            onChange={handleInputChange}
                          />
                          <span className="ml-2">Habilitar Transbordo</span>
                        </label>
                      </div>
                      <p className="help">
                        Se marcado, habilita o transbordo
                      </p>
                    </div>
                  </div>
                </div>

                <div className="columns">
                  <div className="column is-6">
                    <div className="field">
                      <div className="control">
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="recording_enabled"
                            checked={values.recording_enabled}
                            onChange={handleInputChange}
                          />
                          <span className="ml-2">Habilitar Gravação</span>
                        </label>
                      </div>
                      <p className="help">
                        Se marcado, habilita a gravação automática da chamada
                      </p>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="field">
                      <div className="control">
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            name="audio_enabled_main"
                            checked={values.audio_enabled_main}
                            onChange={handleInputChange}
                          />
                          <span className="ml-2">🎵 Reproduzir Áudio Antes do Destino Principal</span>
                        </label>
                      </div>
                      <p className="help">
                        Se marcado, reproduz um áudio antes de encaminhar para o destino principal.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="columns mt-4">
                  <div className="column">
                    <MohConfiguration
                      config={{
                        moh_enabled: values.moh_enabled || false,
                        moh_class: values.moh_class || ''
                      }}
                      tenant={values.tenant}
                      onChange={(mohConfig) => {
                        setValues(prev => ({
                          ...prev,
                          moh_enabled: mohConfig.moh_enabled,
                          moh_class: mohConfig.moh_class
                        }));
                      }}
                      disabled={saving}
                    />
                  </div>
                </div>

                {values.audio_enabled_main && (
                  <div className="box" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                    <h4 className="subtitle is-6">🎵 Configuração de Áudio - Destino Principal</h4>
                    
                    <div className="columns">
                      <div className="column is-6">
                        <div className="field">
                          <label className="label">Método de Reprodução</label>
                          <div className="control">
                            <div className="select is-fullwidth">
                              <select
                                name="audio_method_main"
                                value={values.audio_method_main}
                                onChange={handleInputChange}
                              >
                                <option value="playback">Playback (Bloqueia até terminar)</option>
                                <option value="background">Background (Não bloqueia)</option>
                              </select>
                            </div>
                          </div>
                          <p className="help">
                            <strong>Playback:</strong> Aguarda o áudio terminar antes de continuar<br/>
                            <strong>Background:</strong> Reproduz o áudio em paralelo
                          </p>
                        </div>
                      </div>
                    </div>

                    <AudioSelectorUploads
                      selectedAudio={values.audio_file_main}
                      onAudioChange={(audioData) => {
                        setValues(prev => ({
                          ...prev,
                          audio_file_main: audioData.file,
                          audio_type_main: audioData.type,
                          audio_accountcode_main: audioData.accountcode
                        }));
                      }}
                      tenant={values.tenant}
                      disabled={!values.tenant}
                    />
                  </div>
                )}

                <hr />

                <h2 className="title is-5">
                  📞 Transbordos {values.is_dynamic ? '(Obrigatório)' : '(Opcional)'}
                </h2>

                {(values.overflows.length > 0 ? values.overflows : [{ timeout: '', destination_overflow: '', destination_type: 'endpoint', trunk_name: '' }]).map((overflow, index) => (
                  <div key={index} className="box">
                    <div className="level">
                      <div className="level-left">
                        <div className="level-item">
                          <h3 className="subtitle is-6">Transbordo #{index + 1}</h3>
                        </div>
                      </div>
                      <div className="level-right">
                        <div className="level-item">
                          <button
                            type="button"
                            className="button is-small is-danger"
                            onClick={() => removeOverflow(index)}
                            title="Remover transbordo"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="columns">
                      <div className="column is-4">
                        <div className="field">
                          <label className="label">
                            Timeout (segundos){values.is_dynamic && ' *'}
                          </label>
                          <div className="control">
                            <input
                              className="input"
                              type="number"
                              value={overflow.timeout}
                              onChange={(e) => updateOverflow(index, 'timeout', e.target.value)}
                              placeholder="Ex: 30"
                              min="1"
                              max="300"
                            />
                          </div>
                          <p className="help">
                            Tempo limite para este transbordo (1-300 segundos)
                            {values.is_dynamic && ' - Obrigatório para configurações dinâmicas'}
                            {overflow.destination_type === 'whatsapp' && ' - Obrigatório para WhatsApp'}
                          </p>
                        </div>
                      </div>

                      <div className="column is-4">
                        <div className="field">
                          <label className="label">
                            Destino do Transbordo{values.is_dynamic && overflow.destination_type !== 'whatsapp' && ' *'}
                          </label>
                          <div className="control">
                            {overflow.destination_type === 'whatsapp' ? (
                              <input
                                className="input"
                                type="text"
                                value="WhatsApp (AGI)"
                                disabled
                                style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                              />
                            ) : overflow.destination_type === 'queue' ? (
                              <div className="select is-fullwidth">
                                <select
                                  value={overflow.destination_overflow}
                                  onChange={(e) => updateOverflow(index, 'destination_overflow', e.target.value)}
                                  required={values.is_dynamic}
                                >
                                  <option value="">Selecione uma fila</option>
                                  {queues.map((queue) => (
                                    <option key={queue.name} value={queue.name}>
                                      {queue.name} ({queue.description || 'Sem descrição'})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            ) : overflow.destination_type === 'disa' ? (
                              <div className="select is-fullwidth">
                                <select
                                  value={overflow.destination_overflow}
                                  onChange={(e) => updateOverflow(index, 'destination_overflow', e.target.value)}
                                  required={values.is_dynamic}
                                >
                                  <option value="">Selecione um contexto DISA</option>
                                  {contexts.filter(context => {
                                    const contextName = (context.name || '').toLowerCase();
                                    return isDestinationContext(contextName);
                                  }).map((context, index) => (
                                    <option key={index} value={context.name}>
                                      {context.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            ) : (
                              <input
                                className="input"
                                type="text"
                                value={overflow.destination_overflow}
                                onChange={(e) => updateOverflow(index, 'destination_overflow', e.target.value)}
                                placeholder={
                                  overflow.destination_type === 'external'
                                    ? "Ex: 5511999999999, 011999999999"
                                    : overflow.destination_type === 'cycle'
                                    ? "CYCLE_RESTART (automático)"
                                    : "Ex: 2010, empresa-fila-atendimento"
                                }
                                maxLength="100"
                                required={values.is_dynamic && overflow.destination_type !== 'cycle'}
                                readOnly={overflow.destination_type === 'cycle'}
                                style={overflow.destination_type === 'cycle' ? { backgroundColor: '#f5f5f5', cursor: 'not-allowed' } : {}}
                              />
                            )}
                          </div>
                          <p className="help">
                            {overflow.destination_type === 'whatsapp'
                              ? '🟢 Encaminhamento automático via WhatsApp AGI'
                              : overflow.destination_type === 'cycle' 
                              ? 'Valor automático para reiniciar o ciclo'
                              : overflow.destination_type === 'external'
                              ? 'Número externo para discagem (ex: celular, telefone fixo)'
                              : overflow.destination_type === 'disa'
                              ? 'Selecione o contexto DISA/URA para encaminhar a chamada'
                              : overflow.destination_type === 'queue'
                              ? 'Selecione a fila de atendimento disponível'
                              : `Destino quando o timeout for atingido ${values.is_dynamic ? ' - Obrigatório para configurações dinâmicas' : ' (opcional)'}`
                            }
                          </p>
                        </div>
                      </div>

                      {overflow.destination_type === 'external' && (
                        <div className="column is-4">
                          <div className="field">
                            <label className="label">
                              Tronco{values.is_dynamic && ' *'}
                            </label>
                            <div className="control">
                              <div className="select is-fullwidth">
                                <select
                                  value={overflow.trunk_name || ''}
                                  onChange={(e) => updateOverflow(index, 'trunk_name', e.target.value)}
                                  required={values.is_dynamic}
                                >
                                  <option value="">Selecione um tronco</option>
                                  {trunks.map((trunk, trunkIndex) => (
                                    <option key={trunkIndex} value={trunk.name}>
                                      {trunk.name} ({trunk.description || 'Sem descrição'})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <p className="help">
                              Tronco para realizar a ligação externa{values.is_dynamic ? ' - Obrigatório para configurações dinâmicas' : ' (opcional)'}
                            </p>
                          </div>
                        </div>
                      )}

                      <div className="column is-4">
                        <div className="field">
                          <label className="label">Tipo de Destino</label>
                          <div className="control">
                            <div className="select is-fullwidth">
                              <select
                                value={overflow.destination_type}
                                onChange={(e) => updateOverflow(index, 'destination_type', e.target.value)}
                              >
                                <option value="endpoint">Endpoint (Ramal)</option>
                                <option value="queue">Queue (Fila)</option>
                                <option value="external">Externo</option>
                                <option value="disa">DISA</option>
                                <option value="cycle">Ciclo (Reiniciar)</option>
                                <option value="whatsapp" disabled={!hasWhatsAppIntegration}>
                                  WhatsApp {!hasWhatsAppIntegration && '(Requer integração)'}
                                </option>
                              </select>
                            </div>
                          </div>
                          <p className="help">
                            Tipo do destino do transbordo
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="columns">
                      <div className="column is-12">
                        <div className="field">
                          <div className="control">
                            <label className="checkbox">
                              <input
                                type="checkbox"
                                checked={overflow.audio_enabled || false}
                                onChange={(e) => updateOverflow(index, 'audio_enabled', e.target.checked)}
                              />
                              <span className="ml-2">🎵 Reproduzir Áudio Antes deste Transbordo</span>
                            </label>
                          </div>
                          <p className="help">
                            Se marcado, reproduz um áudio antes de executar este transbordo.
                          </p>
                        </div>
                      </div>
                    </div>

                    {overflow.audio_enabled && (
                      <div className="box" style={{ backgroundColor: '#f0f8ff', border: '1px solid #b3d9ff' }}>
                        <h5 className="subtitle is-6">🎵 Configuração de Áudio - Overflow #{index + 1}</h5>
                        
                        <div className="columns">
                          <div className="column is-6">
                            <div className="field">
                              <label className="label">Método de Reprodução</label>
                              <div className="control">
                                <div className="select is-fullwidth">
                                  <select
                                    value={overflow.audio_method || 'playback'}
                                    onChange={(e) => updateOverflow(index, 'audio_method', e.target.value)}
                                  >
                                    <option value="playback">Playback (Bloqueia até terminar)</option>
                                    <option value="background">Background (Não bloqueia)</option>
                                  </select>
                                </div>
                              </div>
                              <p className="help">
                                <strong>Playback:</strong> Aguarda o áudio terminar<br/>
                                <strong>Background:</strong> Reproduz em paralelo
                              </p>
                            </div>
                          </div>
                        </div>

                        <AudioSelectorUploads
                          selectedAudio={overflow.audio_file || ''}
                          onAudioChange={(audioData) => {
                            const newOverflows = [...values.overflows];
                            newOverflows[index] = {
                              ...newOverflows[index],
                              audio_file: audioData.file,
                              audio_type: audioData.type,
                              audio_accountcode: audioData.accountcode
                            };
                            
                            setValues({
                              ...values,
                              overflows: newOverflows
                            });
                          }}
                          tenant={values.tenant}
                          disabled={!values.tenant}
                        />
                      </div>
                    )}
                  </div>
                ))}

                <div className="field">
                  <div className="control">
                    <button
                      type="button"
                      className="button is-info is-outlined"
                      onClick={addOverflow}
                    >
                      <FontAwesomeIcon icon={faPlus} className="mr-2" />
                      Adicionar Transbordo
                    </button>
                  </div>
                </div>

                <hr />

                <div className="box mt-4">
                  <div className="field">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        checked={values.gotoiftime_enabled}
                        onChange={(e) => setValues({ ...values, gotoiftime_enabled: e.target.checked })}
                      />
                      <span className="ml-2">Habilitar Desvios por Data/Hora</span>
                    </label>
                    <p className="help">
                      Configure desvios baseados em data/hora. As chamadas que atendem às condições serão redirecionadas automaticamente.
                    </p>
                  </div>

                  {values.gotoiftime_enabled && (
                    <TimeConditionManager
                      rules={values.gotoiftime_rules}
                      onChange={(newRules) => setValues({ ...values, gotoiftime_rules: newRules })}
                      availableContexts={contextsFiltered}
                      disabled={saving}
                      title="Desvios por Data/Hora"
                    />
                  )}
                </div>

                {false && values.gotoiftime_rules.map((rule, index) => (
                  <div key={index} className="box">
                    <div className="level">
                      <div className="level-left">
                        <div className="level-item">
                          <h4 className="subtitle is-6">Regra #{index + 1}</h4>
                        </div>
                      </div>
                      <div className="level-right">
                        <div className="level-item">
                          <button
                            type="button"
                            className="button is-small is-danger"
                            onClick={() => removeGotoIfTimeRule(index)}
                            title="Remover regra de horário"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="columns">
                      <div className="column is-3">
                        <div className="field">
                          <label className="label">Horário</label>
                          <div className="control">
                            <input
                              className="input"
                              type="text"
                              placeholder="Ex: 08:00-17:59, *"
                              value={rule.time_range}
                              onChange={(e) => updateGotoIfTimeRule(index, 'time_range', e.target.value)}
                            />
                          </div>
                          <p className="help">HH:MM-HH:MM ou * para sempre</p>
                        </div>
                      </div>

                      <div className="column is-3">
                        <div className="field">
                          <label className="label">Dias da Semana</label>
                          <div className="control">
                            <div className="select is-fullwidth">
                              <select
                                value={rule.days_of_week}
                                onChange={(e) => updateGotoIfTimeRule(index, 'days_of_week', e.target.value)}
                              >
                                <option value="*">Todos os dias</option>
                                <option value="mon-fri">Segunda à Sexta</option>
                                <option value="sat-sun">Sábado e Domingo</option>
                                <option value="mon">Segunda-feira</option>
                                <option value="tue">Terça-feira</option>
                                <option value="wed">Quarta-feira</option>
                                <option value="thu">Quinta-feira</option>
                                <option value="fri">Sexta-feira</option>
                                <option value="sat">Sábado</option>
                                <option value="sun">Domingo</option>
                              </select>
                            </div>
                          </div>
                          <p className="help">Dias da semana para a regra</p>
                        </div>
                      </div>

                      <div className="column is-3">
                        <div className="field">
                          <label className="label">Dias do Mês</label>
                          <div className="control">
                            <div className="select is-fullwidth">
                              <select
                                value={rule.days_of_month}
                                onChange={(e) => updateGotoIfTimeRule(index, 'days_of_month', e.target.value)}
                              >
                                <option value="*">Todos os dias</option>
                                <option value="1-15">1 a 15</option>
                                <option value="16-31">16 a 31</option>
                                <option value="1">Dia 1</option>
                                <option value="15">Dia 15</option>
                                <option value="30">Dia 30</option>
                                <option value="31">Dia 31</option>
                              </select>
                            </div>
                          </div>
                          <p className="help">Dias do mês para a regra</p>
                        </div>
                      </div>

                      <div className="column is-3">
                        <div className="field">
                          <label className="label">Meses</label>
                          <div className="control">
                            <div className="select is-fullwidth">
                              <select
                                value={rule.months}
                                onChange={(e) => updateGotoIfTimeRule(index, 'months', e.target.value)}
                              >
                                <option value="*">Todos os meses</option>
                                <option value="jan-mar">Janeiro a Março</option>
                                <option value="apr-jun">Abril a Junho</option>
                                <option value="jul-sep">Julho a Setembro</option>
                                <option value="oct-dec">Outubro a Dezembro</option>
                                <option value="jan">Janeiro</option>
                                <option value="feb">Fevereiro</option>
                                <option value="mar">Março</option>
                                <option value="apr">Abril</option>
                                <option value="may">Maio</option>
                                <option value="jun">Junho</option>
                                <option value="jul">Julho</option>
                                <option value="aug">Agosto</option>
                                <option value="sep">Setembro</option>
                                <option value="oct">Outubro</option>
                                <option value="nov">Novembro</option>
                                <option value="dec">Dezembro</option>
                              </select>
                            </div>
                          </div>
                          <p className="help">Meses para a regra</p>
                        </div>
                      </div>
                    </div>

                    <div className="columns">
                      <div className="column is-4">
                        <div className="field">
                          <label className="label">Contexto de Destino *</label>
                          <div className="control">
                            <div className="select is-fullwidth">
                              <select
                                value={rule.context_name}
                                onChange={(e) => updateGotoIfTimeRule(index, 'context_name', e.target.value)}
                                required={rule.destination_type === 'context'}
                              >
                                <option value="">Selecione um contexto</option>
                                {contexts.map((context) => (
                                  <option key={context.name} value={context.name}>
                                    {context.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <p className="help">
                            {contexts.length > 0 
                              ? `${contexts.length} contextos disponíveis`
                              : values.tenant 
                                ? 'Carregando contextos...'
                                : 'Selecione um tenant primeiro'
                            }
                          </p>
                        </div>
                      </div>

                      <div className="column is-4">
                        <div className="field">
                          <label className="label">Extensão de Destino *</label>
                          <div className="control">
                            <input
                              className="input"
                              type="text"
                              placeholder="Ex: msg, atendimento, 1000"
                              value={rule.extension_name}
                              onChange={(e) => updateGotoIfTimeRule(index, 'extension_name', e.target.value)}
                              required
                            />
                          </div>
                          <p className="help">Nome da extensão no contexto de destino</p>
                        </div>
                      </div>

                      <div className="column is-4">
                        <div className="field">
                          <label className="label">Prioridade</label>
                          <div className="control">
                            <input
                              className="input"
                              type="number"
                              placeholder="1"
                              min="1"
                              max="999"
                              value={rule.priority}
                              onChange={(e) => updateGotoIfTimeRule(index, 'priority', parseInt(e.target.value) || 1)}
                            />
                          </div>
                          <p className="help">Prioridade da extensão (padrão: 1)</p>
                        </div>
                      </div>
                    </div>

                    <div className="field">
                      <label className="label">Descrição (Opcional)</label>
                      <div className="control">
                        <input
                          className="input"
                          type="text"
                          placeholder="Ex: Fora do expediente, Feriados, etc."
                          value={rule.description}
                          onChange={(e) => updateGotoIfTimeRule(index, 'description', e.target.value)}
                        />
                      </div>
                      <p className="help">Descrição opcional para identificar a regra</p>
                    </div>
                  </div>
                ))}

                <div className="field">
                  <div className="control">
                    <button
                      type="button"
                      className="button is-info is-outlined"
                      onClick={addGotoIfTimeRule}
                    >
                      <FontAwesomeIcon icon={faPlus} className="mr-2" />
                      Adicionar Regra de Horário
                    </button>
                  </div>
                </div>

                <hr />

                <div className="field is-grouped is-grouped-right">
                  <div className="control">
                    <Link to="/config/chamadas/internas" className="button is-light">
                      Cancelar
                    </Link>
                  </div>
                  <div className="control">
                    <button
                      type="submit"
                      className={`button is-primary ${saving ? 'is-loading' : ''}`}
                      disabled={disable || saving}
                    >
                      <FontAwesomeIcon icon={faSave} className="mr-2" />
                      Salvar Configuração
                    </button>
                  </div>
                </div>
              </form>

        <div className="form-section-card">
          <h2 className="form-section-title">
            <span>💡</span> Dicas e Informações
          </h2>
          <div className="content">
            <ul>
              <li><strong>Tenant:</strong> Identifica qual cliente/empresa utilizará esta configuração</li>
              <li><strong>Máscara:</strong> Padrão que será interceptado (ex: 2000, 20XX, _20XX)</li>
              <li><strong>Destino Principal:</strong> Para onde a chamada será direcionada inicialmente</li>
              <li><strong>Tipo de Destino:</strong> endpoint = Dial(), queue = Queue(), disa = Goto()</li>
              <li><strong>Configuração Dinâmica:</strong> Utiliza transbordos automáticos em sequência</li>
              <li><strong>Transbordos:</strong> Destinos alternativos quando o principal falha ou atinge timeout</li>
              <li><strong>Tipo Ciclo:</strong> Reinicia o fluxo do início (evita hangup)</li>
              <li><strong>${'{'}EXTEN{'}'}:</strong> Quando destino for igual à máscara, use ${'{'}EXTEN{'}'} na geração</li>
            </ul>
          </div>
        </div>
      </div>

      {showOverflowDeleteConfirm && (
        <div className="modal is-active">
          <div className="modal-background" onClick={cancelOverflowDeletion}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Confirmar Alteração</p>
              <button className="delete" aria-label="close" onClick={cancelOverflowDeletion}></button>
            </header>
            <section className="modal-card-body">
              <div className="content">
                <p>
                  <strong>Atenção!</strong> Ao desabilitar o transbordo, todas as configurações de transbordo atuais serão <strong>deletadas</strong>.
                </p>
                <p>
                  Esta ação não pode ser desfeita. Deseja continuar?
                </p>
              </div>
            </section>
            <footer className="modal-card-foot">
              <button className="button is-danger" onClick={confirmOverflowDeletion}>
                Sim, deletar transbordos
              </button>
              <button className="button" onClick={cancelOverflowDeletion}>
                Cancelar
              </button>
            </footer>
          </div>
        </div>
      )}
    </>
  );
}

export default InternalCallsEdit;